import {Settings} from 'MyAccount/AccountPage/AccountPageSectionsData';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Subheader from 'material-ui/Subheader';
import LeftMenuItem from '../../shared/components/LeftMenu/LeftMenuItem';
import _ from 'lodash';
import {connect} from 'react-redux';
import * as Colors from 'material-ui/styles/colors';
import {Scrollbars} from 'shared/vendor/react-custom-scrollbars/src/index';
import InlineButton from 'shared/components/InlineButton';
import routes from 'App/routeConstants';
import {CSSGrid, layout, makeResponsive} from 'react-stonecutter';
import ListView from './newComponents/ListView';
import {Tabs, Tab} from 'material-ui/Tabs';
import Paper from 'material-ui/Paper';
import DesignPreview from './DesignPreview';
import {NAV_HEIGHT} from 'Layout/MyAccountLayout/dimensions';
import {LEFT_MENU_WIDTH} from 'MyAccount/ViewTemplates/consts';
import async from 'async';
import {getImage} from 'MyAccount/ViewDesigns/helpers/uploadHelper';
import {updatePrefetchedTemplates} from '../ViewDesigns/redux/modules/templates';
import {getResizeUrl} from 'MyAccount/ViewDesigns/helpers/resizeImageUrlHelper';
import {getTemplatesBySelectedTag} from 'shared/selectors/templatesSelectors';
import {updateTemplates} from 'MyAccount/ViewTemplates/requests';
import updateQuery from 'shared/helpers/updateQuery';
import {getFolderIdByName} from 'MyAccount/ViewTemplates/helpers/folderName';
import SearchField from 'shared/components/SearchField/SearchField';
import {TABS, ebayAllCategories} from 'MyAccount/ViewDesigns/consts';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
import {browserHistory} from 'react-router';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

export const SEE_ALL_THEMES = 'See all themes';
export const BASIC = 'Basic';

const Grid = makeResponsive(CSSGrid, {maxWidth: 1920, minPadding: LEFT_MENU_WIDTH + 60 + 280}); // 280 is the width of the layout drawer when open
const HOME = 'Home';
const VIEW_DESIGN_NAV_MENU_HEIGHT = 70;
const CONTENT_HEIGHT = `calc(100vh - ${NAV_HEIGHT + VIEW_DESIGN_NAV_MENU_HEIGHT}px)`;
const COLUMN_WIDTH = 240;
const styles = {
  container: {
    minHeight: 'inherit',
    position: 'relative',
    fontSize: 16,
    display: 'flex',
    flexDirection: 'column',
    color: Colors.grey700,
    backgroundColor: Colors.grey200,
  },
  leftMenu: {
    width: LEFT_MENU_WIDTH,
    transition: '350ms cubic-bezier(0.23, 1, 0.32, 1)',
    transform: 'translateX(0px)',
    height: CONTENT_HEIGHT,
    position: 'fixed',
    borderRadius: 0,
  },
  topNavigation: {
    height: VIEW_DESIGN_NAV_MENU_HEIGHT,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 0,
    paddingRight: 15,
    backgroundColor: Colors.grey50,
    zIndex: 5,
    left: 0,
    right: 0,
    top: NAV_HEIGHT,
  },
  main: {
    marginLeft: LEFT_MENU_WIDTH,
    height: CONTENT_HEIGHT,
    width: 'auto',
    zIndex: 1,
    display: 'flex',
    overflow: 'hidden',
    marginTop: 8,
  },
};

const TOP_CATEGORIES = ['NEW', 'Most Popular', BASIC, 'General'];

@connectWithRouter(
  state => ({
    templateList: state.templates.templateList,
    categoryList: state.templates.categoryList,
    hireDesignerLink: state.settings.hireDesignerLink,
    selectedTag: state.routing.location.query.selectedTag || SEE_ALL_THEMES,
    query: state.routing.location.query,
    prefetchedTemplates: state.templates.prefetchedTemplates,
    templatesBySelectedTag: getTemplatesBySelectedTag(state),
    userTags: state.user.tags,
    selectedTab: state.routing.location.query.selectedTab || TABS.THEMES,
  }),
  {updatePrefetchedTemplates}
)
export default class NewViewDesigns extends Component {
  state = {
    filter: '',
  };

  componentWillMount() {
    const {templateList, templatesBySelectedTag, selectedTab, selectedTag} = this.props;
    if (selectedTab === TABS.SAVED_TEMPLATES) {
      updateTemplates(getFolderIdByName(selectedTag));
      this.fetchTemplates(templatesBySelectedTag);
    }
    this.fetchTemplates(templateList);
  }

  componentDidUpdate(prevProps) {
    const {templatesBySelectedTag, selectedTab, selectedTag} = this.props;
    if (prevProps.selectedTag !== selectedTag || prevProps.selectedTab !== selectedTab) {
      if (selectedTab === TABS.SAVED_TEMPLATES) {
        updateTemplates(getFolderIdByName(selectedTag));
      }
      if (templatesBySelectedTag !== prevProps.templatesBySelectedTag) {
        this.fetchTemplates(templatesBySelectedTag);
      }
    }
  }

  getTopMenuCategories = categories => {
    const {selectedTab} = this.props;
    return (
      <div
        style={{
          borderColor: Colors.grey400,
          borderTopWidth: 0,
          borderStyle: 'solid',
          borderBottomWidth: 1,
          borderLeftWidth: 0,
          borderRightWidth: 0,
        }}
      >
        {selectedTab === TABS.THEMES
          ? [
              this.renderMenuItem({id: 'all', name: SEE_ALL_THEMES}),
              ..._.map(TOP_CATEGORIES, topCategory => {
                return this.renderMenuItem(_.get(categories, topCategory));
              }),
            ]
          : this.renderMenuItem({id: HOME, name: HOME})}
      </div>
    );
  };

  getCategory = filter => {
    let ans = filter;
    _.forEach(ebayAllCategories, (categorySubCategories, category) => {
      if (category.toLowerCase() === filter.toLowerCase()) {
        ans = category;
      }
      const found = _.find(categorySubCategories, categorySubCategory => {
        return filter === categorySubCategory;
      });
      if (!_.isNil(found)) {
        ans = category;
      }
    });
    return ans;
  };

  getTabDefaultData = toTab => {
    if (toTab === TABS.THEMES) {
      return {selectedTag: SEE_ALL_THEMES};
    }
    if (toTab === TABS.SAVED_TEMPLATES) {
      return {selectedTag: HOME};
    }
  };

  getHeadlines = () => {
    const {templatesBySelectedTag, hireDesignerLink} = this.props;
    if (!_.isEmpty(templatesBySelectedTag)) {
      return {
        headLine: 'Pick The Theme You Love',
        secondaryHeadline: 'Start with one of our themes, then change anything you want to make it your own',
        designerLink: (
          <span>
            Don’t want to design yourself?{' '}
            <InlineButton href={hireDesignerLink}>Hire a professional designer</InlineButton>
          </span>
        ),
      };
    }
    return {
      headLine: "We're sorry, no themes were found for your search",
      secondaryHeadline: (
        <span>
          Need a theme for a category we don't cover?{' '}
          <InlineButton
            onClick={() => {
              window.Intercom('showNewMessage', 'Hello Crazylister\n' + 'I would like to request a new theme:\n');
            }}
          >
            Ask us to add a theme
          </InlineButton>
          .
        </span>
      ),
    };
  };

  searchFieldReset = () => {
    const {searchField} = this.refs;
    if (searchField) {
      searchField.reset();
    }
  };

  ebayAllCategoriesArray = _.reduce(
    ebayAllCategories,
    (result, subCategories, category) => {
      if (
        _.find(_.keys(this.props.categoryList), categoryWithListings => {
          return categoryWithListings === category;
        })
      ) {
        return _.concat(result, category, subCategories);
      }
      return result;
    },
    []
  );

  queue = async.queue((template, callback) => {
    const previewUrl = getResizeUrl(template.previewUrl, {width: COLUMN_WIDTH});
    getImage(previewUrl, img => {
      if (img && img.height > 0) {
        this.props.updatePrefetchedTemplates({...template, previewUrl, img});
      }
      callback();
    });
  }, 10);

  fetchTemplates = listToFetch => {
    const {prefetchedTemplates} = this.props;
    _.forEach(listToFetch, template => {
      const needToAdd = !_.find(prefetchedTemplates, {
        id: template.id,
        previewUrl: getResizeUrl(template.previewUrl, {width: COLUMN_WIDTH}),
      });
      if (needToAdd) {
        this.queue.push(template);
      }
    });
  };

  changeCategory = target => {
    const {selectedTag} = this.state;
    if (target !== selectedTag && !_.isEmpty(target)) {
      updateQuery({selectedTag: this.getCategory(target)});
    }
  };

  changeTab = ({props: {value}}) => {
    const {selectedTag} = this.getTabDefaultData(value);
    this.searchFieldReset();
    updateQuery({selectedTab: value, selectedTag: selectedTag}, true);
  };

  organizeTags = objects => {
    const keys = _.keys(objects);
    const ans = {};
    _.forEach(keys, key => {
      ans[key] = {id: key, name: objects[key]};
    });
    return ans;
  };

  renderMenuItem = category => {
    if (_.isEmpty(category)) {
      return null;
    }
    const {selectedTag, query} = this.props;
    const {name, id} = category;
    return (
      <LeftMenuItem
        key={'category_' + id}
        primaryText={name}
        selected={name === selectedTag}
        to={{
          pathname: routes.MyAccount.ViewDesigns,
          query: {...query, selectedTag: name},
        }}
        onClick={this.searchFieldReset}
      />
    );
  };

  render() {
    const {prefetchedTemplates, templatesBySelectedTag, userTags, selectedTab, categoryList} = this.props;
    const {filter} = this.state;
    const sideBarList =
      selectedTab === TABS.THEMES
        ? _.sortBy(_.omit(categoryList, TOP_CATEGORIES), [
            category => {
              return _.toLower(category.name);
            },
          ])
        : this.organizeTags(userTags);
    const topMenuCategories = this.getTopMenuCategories(categoryList);
    const subHeaderText = selectedTab === TABS.THEMES ? 'Categories' : 'Template Folders';
    const {headLine, secondaryHeadline, designerLink} = this.getHeadlines();
    const hintText = selectedTab === TABS.THEMES ? 'Search themes...' : 'Search saved templates...';
    return (
      <div style={{height: `calc(100vh - ${NAV_HEIGHT}px)`, overflow: 'hidden', backgroundColor: Colors.grey200}}>
        <Paper style={styles.topNavigation}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <IconButton onClick={() => browserHistory.push({pathname: routes.MyAccount.ViewTemplatesBase})}>
              <ArrowBackIcon />
            </IconButton>
            <div style={{fontSize: 20, marginLeft: 8}}>Select a design to start with</div>
          </div>
          <Tabs
            style={{
              width: 350,
              flexShrink: 0,
              alignSelf: 'flex-end',
            }}
            tabItemContainerStyle={{backgroundColor: Colors.transparent}}
            value={selectedTab}
          >
            <Tab
              buttonStyle={{height: `${NAV_HEIGHT}px`}}
              label={
                <span
                  style={{
                    height: `${NAV_HEIGHT}px`,
                    display: 'flex',
                    alignItems: 'center',
                    color: Colors.grey700,
                  }}
                >
                  themes
                </span>
              }
              value={TABS.THEMES}
              onActive={this.changeTab}
            />
            <Tab
              buttonStyle={{height: `${NAV_HEIGHT}px`}}
              label={
                <span style={{height: `${NAV_HEIGHT}px`, display: 'flex', alignItems: 'center', color: Colors.grey700}}>
                  saved templates
                </span>
              }
              value={TABS.SAVED_TEMPLATES}
              onActive={this.changeTab}
            />
          </Tabs>
          <SearchField
            ref="searchField"
            hintText={hintText}
            style={{maxWidth: 300, flexShrink: 1}}
            onChange={filter =>
              selectedTab === TABS.SAVED_TEMPLATES ? this.setState({filter}) : this.changeCategory(filter)
            }
            dataSource={selectedTab === TABS.SAVED_TEMPLATES ? [] : this.ebayAllCategoriesArray}
          />
        </Paper>
        <Scrollbars style={{...styles.leftMenu, zIndex: 1, marginTop: 8}}>
          <div style={{paddingRight: 8}}>
            {topMenuCategories}
            <Subheader>{subHeaderText}</Subheader>
            {_.map(sideBarList, entry => {
              return this.renderMenuItem(entry);
            })}
          </div>
          <div style={{height: 30}} />
        </Scrollbars>
        {selectedTab === TABS.SAVED_TEMPLATES ? (
          <div style={styles.main}>
            <ListView
              filter={filter}
              onChangeTab={value => {
                this.changeTab({props: {value}});
              }}
            />
          </div>
        ) : (
          <Scrollbars style={styles.main}>
            <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
              <div style={{height: 135}}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: '75%',
                    paddingTop: 20,
                  }}
                >
                  <div style={{fontSize: 24, color: Colors.grey600}}>{headLine}</div>
                  <div style={{fontSize: 18, color: Colors.grey500}}>{secondaryHeadline}</div>
                  <div style={{fontSize: 16, color: Colors.grey500, marginTop: 10}}>{designerLink}</div>
                </div>
              </div>
              <Grid
                columnWidth={COLUMN_WIDTH}
                gutterWidth={25}
                gutterHeight={65}
                layout={layout.pinterest}
                duration={450}
                easing="ease-out"
                style={{marginBottom: 50}}
              >
                {_.map(prefetchedTemplates, template => {
                  const {
                    id,
                    img: {height, width},
                  } = template;
                  if (templatesBySelectedTag[id]) {
                    const itemHeight = (COLUMN_WIDTH * height) / width;
                    return (
                      <div itemHeight={itemHeight} key={id}>
                        <DesignPreview width={COLUMN_WIDTH} height={itemHeight} template={template} />
                      </div>
                    );
                  }
                })}
              </Grid>
            </div>
          </Scrollbars>
        )}
      </div>
    );
  }
}
